<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between margin-bottom-sm page-title">
            <b>入会申请单</b>
        </div>


        <div class="invitation-box">
            <div class="code-img" ref="newImg">
                <img :src="imgUrl + 'qrcode/fh_zc_' + mid +'.png?v='+new Date().getTime()" >
            </div>
            <div class="flex justify-center margin-tb">
                <a :href="imgUrl + 'qrcode/fh_zc_' + mid +'.png?v='+new Date().getTime()" target="_blank" download="asd.png">
                    <el-button round class="blue-btn">下载入会申请二维码</el-button>
                </a>
            </div>
            <div class="copy-box">
                <div class="copy-box-bg">
                    <div class="copy-box-left">
                        <div>网址 : &nbsp;</div>
                        <div ref="copy">{{yuMing + 'invitation/' + mid  + '?type=1'}}</div>
                    </div>
                    <div class="copy-box-right" @click="copy"><el-button round class="blue-btn">复制入会申请链接</el-button></div>

                </div>
            </div>
        </div>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="form margin-top" label-width="auto">
            <el-row :gutter="20">
                <div class="title margin-bottom-sm">邀请设置</div>
                <el-col :span="12">
                    <el-form-item label="是否显示机构注册" prop="cert_name">
                        <el-radio-group v-model="ruleForm.showOrgRegister">
                            <el-radio :label="1">显示</el-radio>
                            <el-radio :label="0">不显示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否显示个人注册" prop="cert_name">
                        <el-radio-group v-model="ruleForm.showGerenRegister">
                            <el-radio :label="1">显示</el-radio>
                            <el-radio :label="0">不显示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
<!--                <el-col :span="12">-->
<!--                    <el-form-item label="注册成功前支付" prop="cert_name">-->
<!--                        <el-radio-group v-model="ruleForm.registerPay">-->
<!--                            <el-radio :label="1">支付</el-radio>-->
<!--                            <el-radio :label="0">不支付</el-radio>-->
<!--                        </el-radio-group>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="24">
                    <el-form-item label="是否通过后短信通知" prop="cert_name">
                        <el-radio-group v-model="ruleForm.smsNotice">
                            <el-radio :label="1">通知</el-radio>
                            <el-radio :label="0">不通知</el-radio>
                        </el-radio-group>
                        <div class="text-red">注:如果选择通知将会在审核通过后消耗短信条数</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="flex align-center justify-center" v-if="user.isBranch">
                <el-button :loading="loading" class="blue-btn" @click="submitForm('ruleForm')">
                    保存
                </el-button>
            </div>
        </el-form>


    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import {IMAGE_PATH,HOSTPATH} from "@/config";
import {getWebSetInfo,setWebSet} from "@/api/branch";

export default {
    name: "invitation",
    data() {
        return {
            imgUrl: '',
          yuMing: '',
            mid:'',
            ruleForm: {
                showGerenRegister: 1,
                showOrgRegister: 1,
                registerPay: 1,
                smsNotice: 1,
            },
            rules:{},
            loading:false
        }
    },
    computed:{
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [3, 2], '会员邀请')
        this.mid = this.user.fhid
        this.imgUrl =IMAGE_PATH
        this.yuMing = HOSTPATH
        this.init()
    },
    components: {

    },
    methods: {
        setImage() {
            html2canvas(this.$refs.newImg, {
                backgroundColor: null
            }).then((canvas) => {
                this.dataURL = canvas.toDataURL("image/png");
            })
        },

        // 邀请函下载
        downs() {
            // 保存二维码
            var url = this.yuMing + 'qrcode/fh_zc_' + this.mid +'.png'
            var a = document.createElement('a')
            a.download = name || 'pic'
            a.href = url
            a.click()
        },

        // 复制地址
        copy() {
            let Url2 = this.$refs.copy.innerText
            let oInput = document.createElement('input')
            oInput.value = Url2
            document.body.appendChild(oInput)
            oInput.select() // 选择对象
            document.execCommand("Copy") // 执行浏览器复制命令
            oInput.className = 'oInput'
            oInput.style.display = 'none'
            this.$message({
                message: '复制网址成功',
                type: 'success'
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.setWebSet();
                }
            });
        },
        async init() {
            let _data = await getWebSetInfo()
            this.ruleForm.showGerenRegister = _data.data.show_geren_register
            this.ruleForm.showOrgRegister = _data.data.show_org_register
            this.ruleForm.registerPay = _data.data.register_pay
            this.ruleForm.smsNotice = _data.data.sms_notice
        },
        async setWebSet() {
            this.loading = true
            let _data = await setWebSet(this.ruleForm.showGerenRegister, this.ruleForm.showOrgRegister,
                this.ruleForm.registerPay,this.ruleForm.smsNotice)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success(_data.msg)
            }else {
                this.$message.error(_data.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

.form {
    border: 1px solid #eeeeee;
    padding: 20px;
    .title{
        font-size: 18px;
        font-weight: bold;
    }
}
    .invitation-box{
        width: 520px;
        margin: 30px auto;
        .code-img{
            img{
                display: block;
                width: 300px;
                margin: 0 auto;
            }
        }
        .copy-box {
            width: 572px;
            height: 60px;
            margin: 0 auto;
            background:#f3f7fb;
            display: flex;
            justify-content: center;
            align-items: center;

            .copy-box-bg {
                width: 548px;
                height: 42px;
                background-color: #ffffff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 21px;

                .copy-box-left {
                    margin-left: 15px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .copy-box-right {
                    cursor: pointer;
                }
            }
        }
    }
</style>